export enum MessagingChannel {
    whatsapp = 'whatsapp',
    messenger = 'messenger',
    instagram = 'instagram',
    website_chat = 'website_chat',
    email = 'email',
}

/**
 * Features of the channel
 */
export enum MessagingChannelFeature {
    /** Contact ID that identify same contact across different channel accounts used (not channel account/provider scoped) */
    contactGlobalId = 'contactGlobalId',
    /** Phone number property for channel contact, optional or not */
    contactPhoneNumber = 'contactPhoneNumber',
    /** Contact ID is valid unique phone number */
    contactPhoneNumberId = 'contactPhoneNumberId',
    /** Phone number property for channel account, optional or not */
    channelPhoneNumber = 'channelPhoneNumber',
    /** Channel account ID is valid unique phone number  */
    channelPhoneNumberId = 'channelPhoneNumberId',
    /** Templates for messages that stored on provider side preliminarily to be used to send new messages */
    templates = 'templates',
    /** Sending any files in the messages */
    attachments = 'attachments',
    /** Supports sending "user typing" events */
    typingNotifySend = 'typingNotify',
    /** Delete message from recepient after it was sent */
    deleteMessage = 'deleteMessage',
    /** Send message quoting another one */
    outboundMessageQuote = 'outboundMessageQuote',
    /** Adapter is able to setup webhooks programmatically */
    webhooksSetAuto = 'webhooksSetAuto',
    /** React on messages ("like" button, etc) */
    messageReactionSend = 'messageReactionSend',
    /** Receive customer "likes" on messages */
    messageReactionReceive = 'messageReactionReceive',
    /** Account profile information edit API */
    profileInfoEdit = 'profileInfoEdit',
    /** Account profile picture edit API */
    profilePictureEdit = 'profilePictureEdit',
    /**
     * Having data retrieval through regular pulling
     */
    pull = 'pull',
}
